// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { Modal } from 'react-bootstrap';
import MediaQuery from 'react-responsive';

import useMessage from '../../../components/common/toast/UseMessage';
import TopHeader from '../../../components/common/topHeader';
import ScratchItem from '../../../components/pages/scratch/scratchRetail/ScratchItem';
import { PurchaseApis } from '../../../services/purchase';
import { hideLoading, showLoading } from '../../../store/features/loadingPage';

import './index.scss';
import { useHistory } from 'react-router-dom';
import {
  GiftBoxBlue,
  GiftBoxRed,
  GiftBoxYellow,
  OpenBoxYellow,
  OpenBoxBlue,
  OpenBoxRed,
  ScratchBackground,
  SkipButton,
  ScratchScale,
  NextButton,
  NewTag,
  Box1,
  Box2,
  Box3,
  WChanceBG,
  WChanceTicket,
  WChanceMiss,
  Congratulations,
  wChangeAnimation2,
  getImage,
  WChanceOn,
  BGWhite,
  dottedScratchPC,
  dottedScratchSP,
  dottedYellowScratchPC,
  dottedYellowScratchSP,
  dottedYellowChoosePrizePC,
} from '../../../../assets/imgs';
import {
  ON_CHALLENGE,
  listsErrorNotShowToast,
  BREAK_POINT,
  SKIP_SCRATCH,
} from '../../../constants';

const BoxAnimation = styled.div`
  ${(props) => props.isShow && 'animation: zoom-in-zoom-out 2s ease-in-out normal;'}
`;

const ScratchWrapper = styled.div`
  background-image: url(${ScratchBackground});
  background-size: 100% 100%;
  background-repeat: no-repeat;
`;

const ScratchWChanceWrapper = styled.div`
  background-image: url(${WChanceBG});
  background-size: 100% 100%;
  background-repeat: no-repeat;
`;

const ButtonSkip = styled.div`
  background-image: url(${SkipButton});
  width: 199px;
  height: 66px;
  background-size: 199px 66px;
  position: absolute;
  top: 25px;
  right: 25px;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    top: 11px;
    right: 10px;
    width: 90px;
    height: 33px;
    background-size: contain;
    background-repeat: no-repeat;
  }
`;
const ButtonSkipCustom = styled.div`
  background-image: url(${SkipButton});
  width: 165px;
  height: 52px;
  background-size: 165px 52px;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    width: 90px;
    height: 33px;
    background-size: contain;
    background-repeat: no-repeat;
  }
`;

export const STEP = {
  OPEN_MODAL: 1,
  SHOW_SCRATCH: 2,
  SCRATCH: 3,
  SHOW_RESULT: 4,
  SHOW_POPUP_CHOOSE_PRIZE: 5,
  SHOW_W_CHANCE: 6,
  SHOW_W_CHANCE_TICKET: 7,
  SHOW_W_CHANCE_ANIMATION_1: 8,
  SHOW_W_CHANCE_ANIMATION_2: 9,
  SHOW_W_CHANCE_RESULT: 10,
};

export const STEP_OPEN_BOX = {
  CLOSE: 0,
  OPEN: 1,
  PUSH_CARD: 2,
};

export default function ScratchUI(props) {
  const { orderId, type, setAdultPurchase } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const pathSite = history.location.pathname;
  const pathLotteryTrial = ['/scratch/trial/retail', '/scratch/trial/package'];
  const { openMessageError, openMessage } = useMessage();

  const [prizesData, setPrizesData] = useState([]);
  const [prizeCanChange, setPrizeCanChange] = useState();
  const [listPrizeCanChange, setListPrizeCanChange] = useState([]);
  const [valuePrizeCanChange, setValuePrizeCanChange] = useState();
  const [animations, setAnimations] = useState([]);
  const [wChanceData, setWChanceData] = useState(undefined);
  const [wChanceFlag, setWChanceFlag] = useState(false);

  const [isShowModalScratch, setShowModalScratch] = useState(false);

  const [stepOpenBox, setStepOpenBox] = useState(STEP_OPEN_BOX.CLOSE);
  const [selectedBoxColor, setColor] = useState('');

  const [rankACounter, setRankACounter] = useState(0);
  const [rankBCounter, setRankBCounter] = useState(0);
  const [rankCCounter, setRankCCounter] = useState(0);
  const [rankDCounter, setRankDCounter] = useState(0);
  const [rankECounter, setRankECounter] = useState(0);

  const [step, setStep] = useState(STEP.OPEN_MODAL);
  const [isScratchWChance, setScratchWChance] = useState(false);
  const [isBgNextChoosePrize, setIsBgNextChoosePrize] = useState(true);
  const [listRank, setListRank] = useState();
  const [valueRankByPrizeWon, setValueRankByPrizeWon] = useState({ title: '', image: null });

  const [counter, setCounter] = useState(0);
  const [userAgent, setUserAgent] = useState('');

  const getListPrizeChangeByRankName = (key, object) => {
    const result = [];
    const value = object[key];

    if (value) {
      result.push(value);
    }
    setListPrizeCanChange(result.flat());
    if (dataTrial.has_use_quantity === true && result.flat().every((item) => item.quantity <= 0)) {
      setIsBgNextChoosePrize(false);
    } else {
      setIsBgNextChoosePrize(true);
    }
  };

  const handleChangePrize = async (order_id, prize_id) => {
    dispatch(showLoading());
    try {
      const res = await PurchaseApis.scratchChangePrize({
        prize_id: prize_id,
        order_detail_id: order_id,
      });
      openMessage({ message: res?.data?.message, variant: 'success' });
      if (counter >= prizesData.length - 1) {
        if (!wChanceFlag && typeof wChanceData === 'undefined') {
          setStep(STEP.OPEN_MODAL);
          handleMoveResult(orderId);
        } else {
          setStep(STEP.SHOW_W_CHANCE);
          setScratchWChance(true);
        }
      } else {
        setStep(STEP.OPEN_MODAL);
        if (counter < prizesData.length) {
          setCounter(counter + 1);
        }
      }

      setShowModalScratch(false);
    } catch (error) {
      if (!listsErrorNotShowToast.includes(Number(error?.response?.status))) {
        openMessageError(error);
      }
    } finally {
      dispatch(hideLoading());
      setValuePrizeCanChange(null);
    }
  };

  const convertRankNameToAnimation = (rankName) => {
    switch (rankName) {
      case 'A':
        return step === STEP.SHOW_SCRATCH ? animations.image_rank_a[0] : animations.image_rank_a[1];
      case 'B':
        return step === STEP.SHOW_SCRATCH ? animations.image_rank_b[0] : animations.image_rank_b[1];
      default:
        return animations.image_normal;
    }
  };

  const calcRankQuantity = (rankName) => {
    switch (rankName) {
      case 'A':
        return setRankACounter(rankACounter + 1);
      case 'B':
        return setRankBCounter(rankBCounter + 1);
      case 'C':
        return setRankCCounter(rankCCounter + 1);
      case 'D':
        return setRankDCounter(rankDCounter + 1);
      case 'E':
        return setRankECounter(rankECounter + 1);
    }
  };

  // FAKE_POP_UP_UI
  useEffect(() => {
    const content = document.getElementsByClassName('content');
    content[0].style.backgroundColor = '#707070';
    return () => (content[0].style.backgroundColor = 'unset');
  });

  const [adult, setAdult] = useState();
  const stateScratchTrial = history?.location?.state;

  const [dataTrial, setDataTrial] = useState();
  const handleMoveResult = (id) => {
    if (pathLotteryTrial.includes(pathSite)) {
      history.push({ pathname: '/result/trial', state: dataTrial });
    } else {
      history.push(`/result?order_id=${id}`);
    }
  };

  useEffect(() => {
    const userAgentVersion = window.navigator.userAgent.toLowerCase();
    if (userAgentVersion.indexOf('win') !== -1) {
      setUserAgent('windows');
    } else if (userAgentVersion.indexOf('mac') !== -1) {
      setUserAgent('mac-android');
    } else if (userAgentVersion.indexOf('android') !== -1) {
      setUserAgent('mac-android');
    } else if (userAgentVersion.indexOf('linux') !== -1) {
      setUserAgent('linux');
    }
  }, []);

  useEffect(async () => {
    dispatch(showLoading());
    try {
      const res = pathLotteryTrial.includes(pathSite)
        ? await PurchaseApis.scratchTrial({
            quantity: stateScratchTrial?.quantity,
            adultPurchase: stateScratchTrial?.adultPurchaseFlag,
          })
        : await PurchaseApis.scratch({
            order_id: orderId,
          });

      const { data } = res;

      setAdult(data?.adult_purchase_flag);
      setDataTrial(data);
      setAdultPurchase(data?.adult_purchase_flag);
      setWChanceFlag(data.have_on_challenge);
      setPrizeCanChange(data.prize_can_change);
      setAnimations(data.animations);
      setListRank(data.ranks);
      const __prizeData = data.prizes.filter((item) => item.rank_name !== ON_CHALLENGE);
      if (__prizeData) {
        setPrizesData(__prizeData);
      }
      const __wChanceData = data.prizes.find((item) => item.rank_name === ON_CHALLENGE);
      if (__wChanceData) {
        setWChanceData(__wChanceData);
      }
      if (!__prizeData.length && !__wChanceData) {
        handleMoveResult(orderId);
      }
    } catch (err) {
      if (!listsErrorNotShowToast.includes(Number(error?.response?.status))) {
        openMessageError(error);
      }
    } finally {
      dispatch(hideLoading());
    }
  }, []);

  const handleNextStep = (rankName = '') => {
    switch (step) {
      case STEP.OPEN_MODAL:
        if (['A', 'B'].includes(rankName)) {
          setStep(STEP.SHOW_SCRATCH);
        } else {
          setStep(STEP.SCRATCH);
        }
        break;
      case STEP.SHOW_SCRATCH:
        setStep(STEP.SCRATCH);
        break;
      case STEP.SCRATCH:
        if (
          typeof prizeCanChange === 'object' &&
          Object.prototype.hasOwnProperty.call(prizeCanChange, prizesData[counter].rank_name)
        ) {
          const value = listRank[prizesData[counter].rank_name];
          setValueRankByPrizeWon({
            rank_name: value.rank_name,
            title: `${value.rank_name}賞の${value.title}`,
            image: value.image !== null ? value.image[0].image_url : BGWhite,
          });
        } else {
          setValueRankByPrizeWon({
            image: prizesData[counter]?.image?.image_url,
            title: `${prizesData[counter]?.rank_name} - ${prizesData[counter]?.number_order} ${prizesData[counter]?.title}`,
          });
        }
        setStep(STEP.SHOW_RESULT);
        break;
      case STEP.SHOW_RESULT:
        calcRankQuantity(prizesData[counter].rank_name);
        setValueRankByPrizeWon({ title: '', image: null });
        if (
          typeof prizeCanChange === 'object' &&
          Object.keys(prizeCanChange).filter((item) => item === prizesData[counter].rank_name)
            .length > 0
        ) {
          getListPrizeChangeByRankName(prizesData[counter].rank_name, prizeCanChange);
          setStep(STEP.SHOW_POPUP_CHOOSE_PRIZE);
          setShowModalScratch(true);
        } else {
          if (counter >= prizesData.length - 1) {
            if (!wChanceFlag && typeof wChanceData === 'undefined') {
              setStep(STEP.OPEN_MODAL);
              handleMoveResult(orderId);
            } else {
              setStep(STEP.SHOW_W_CHANCE);
              setScratchWChance(true);
            }
          } else {
            setStep(STEP.OPEN_MODAL);
            if (counter < prizesData.length) {
              setCounter(counter + 1);
            }
          }
          setShowModalScratch(false);
        }
        break;
      case STEP.SHOW_POPUP_CHOOSE_PRIZE:
        if (
          valuePrizeCanChange ||
          (dataTrial.has_use_quantity === true &&
            listPrizeCanChange.every((item) => item.quantity <= 0))
        ) {
          if (valuePrizeCanChange) {
            handleChangePrize(prizesData[counter].order_detail_id, valuePrizeCanChange);
          }
        }
        return;
      case STEP.SHOW_W_CHANCE:
        setStep(STEP.SHOW_W_CHANCE_TICKET);
        setShowModalScratch(true);
        break;
      case STEP.SHOW_W_CHANCE_TICKET:
        setStep(STEP.SHOW_W_CHANCE_ANIMATION_1);
        break;
      case STEP.SHOW_W_CHANCE_ANIMATION_1:
        if (isEmpty(wChanceData)) {
          setStep(STEP.SHOW_W_CHANCE_RESULT);
        } else {
          setStep(STEP.SHOW_W_CHANCE_ANIMATION_2);
        }
        break;
      case STEP.SHOW_W_CHANCE_ANIMATION_2:
        setStep(STEP.SHOW_W_CHANCE_RESULT);
        break;
      default:
        setScratchWChance(false);
        setShowModalScratch(false);
        setStep(STEP.OPEN_MODAL);
        handleMoveResult(orderId);
        break;
    }
  };

  const convertTime = (rankName, order) => {
    let time = 0;

    if (order === 0) {
      switch (rankName) {
        case 'A':
          time = animations?.time_rank_a ? animations?.time_rank_a[0] : 0;
          break;

        case 'B':
          time = animations?.time_rank_b ? animations?.time_rank_b[0] : 0;
          break;

        default:
          time = 2000;
          break;
      }
    } else {
      switch (rankName) {
        case 'A':
          time = animations?.time_rank_a ? animations?.time_rank_a[1] : 0;
          break;

        case 'B':
          time = animations?.time_rank_b ? animations?.time_rank_b[1] : 0;
          break;

        default:
          time = 2000;
          break;
      }
    }
    return time;
  };

  useEffect(() => {
    if (isShowModalScratch) {
      const interval = setInterval(function () {
        if (step === STEP.SHOW_W_CHANCE_ANIMATION_1 || step === STEP.SHOW_W_CHANCE_ANIMATION_2) {
          handleNextStep();
        }
      }, 2000);
      return () => clearInterval(interval);
    }
  }, [step]);

  useEffect(() => {
    if (isShowModalScratch) {
      const interval = setInterval(function () {
        if (step === STEP.SCRATCH) {
          handleNextStep();
        }
      }, convertTime(prizesData[counter]?.rank_name, 1));
      return () => clearInterval(interval);
    }
  }, [step]);

  useEffect(() => {
    if (isShowModalScratch) {
      const interval = setInterval(function () {
        if (step === STEP.SHOW_SCRATCH) {
          handleNextStep();
        }
      }, convertTime(prizesData[counter]?.rank_name, 0));
      return () => clearInterval(interval);
    }
  }, [step]);

  useEffect(() => {
    if (type === 'package' && stepOpenBox === STEP_OPEN_BOX.PUSH_CARD) {
      let interval = null;

      // WAIT 750 MilI SECOND FOR SHOW ANIMATION PUSH CARD
      setTimeout(() => {
        if (counter < prizesData.length) {
          interval = setInterval(function () {
            if (['A', 'B', 'C'].includes(prizesData[counter].rank_name)) {
              if (!isScratchWChance) {
                setShowModalScratch(true);
              }
            } else {
              if (counter < prizesData.length) {
                setCounter(counter + 1);
              }
            }
          }, 750);
          if (!['A', 'B', 'C'].includes(prizesData[counter].rank_name)) {
            calcRankQuantity(prizesData[counter].rank_name);
          }
        } else {
          if (typeof wChanceData === 'undefined' && !wChanceFlag) {
            handleMoveResult(orderId);
          } else {
            setStep(STEP.SHOW_W_CHANCE);
            setScratchWChance(true);
          }
        }
      }, 200);

      return () => clearInterval(interval);
    }
  }, [type, stepOpenBox, prizesData, counter, isScratchWChance]);

  const renderListScratchItem = () => {
    const result = [];
    for (let i = 0; i < 6; i++) {
      result.push(<ScratchItem onClickItem={() => setShowModalScratch(true)} />);
    }
    return result;
  };

  const formatNumber = (number, isDE = false) => {
    if (number <= 9) {
      return (
        <>
          <MediaQuery minWidth={BREAK_POINT + 1}>
            <>
              {isDE ? (
                <>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="46"
                      viewBox="0 0 40 70"
                    >
                      <g id="Group_7366" data-name="Group 7366" transform="translate(-713 -1047)">
                        <rect
                          id="Rectangle_4216"
                          data-name="Rectangle 4216"
                          width="40"
                          height="50"
                          transform="translate(713 1060)"
                          fill="#464646"
                        />
                        <text
                          id="_0"
                          data-name="0"
                          transform="translate(719 1103)"
                          fill="#fff"
                          fontSize="48"
                          fontFamily="AOTFShinMaruGoPro"
                          fontWeight="500"
                        >
                          <tspan x="0" y="0">
                            0
                          </tspan>
                        </text>
                      </g>
                    </svg>
                  </div>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="46"
                      viewBox="0 0 40 70"
                    >
                      <g id="Group_7366" data-name="Group 7366" transform="translate(-713 -1047)">
                        <rect
                          id="Rectangle_4216"
                          data-name="Rectangle 4216"
                          width="40"
                          height="50"
                          transform="translate(713 1060)"
                          fill="#464646"
                        />
                        <text
                          id="_0"
                          data-name="0"
                          transform="translate(719 1103)"
                          fill="#fff"
                          fontSize="48"
                          fontFamily="AOTFShinMaruGoPro"
                          fontWeight="500"
                        >
                          <tspan x="0" y="0">
                            {number}
                          </tspan>
                        </text>
                      </g>
                    </svg>
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="70"
                      viewBox="0 0 40 70"
                    >
                      <g id="Group_7366" data-name="Group 7366" transform="translate(-713 -1047)">
                        <rect
                          id="Rectangle_4216"
                          data-name="Rectangle 4216"
                          width="40"
                          height="50"
                          transform="translate(713 1060)"
                          fill="#464646"
                        />
                        <text
                          id="_0"
                          data-name="0"
                          transform="translate(719 1103)"
                          fill="#fff"
                          fontSize="48"
                          fontFamily="AOTFShinMaruGoPro"
                          fontWeight="500"
                        >
                          <tspan x="0" y="0">
                            0
                          </tspan>
                        </text>
                      </g>
                    </svg>
                  </div>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="70"
                      viewBox="0 0 40 70"
                    >
                      <g id="Group_7366" data-name="Group 7366" transform="translate(-713 -1047)">
                        <rect
                          id="Rectangle_4216"
                          data-name="Rectangle 4216"
                          width="40"
                          height="50"
                          transform="translate(713 1060)"
                          fill="#464646"
                        />
                        <text
                          id="_0"
                          data-name="0"
                          transform="translate(719 1103)"
                          fill="#fff"
                          fontSize="48"
                          fontFamily="AOTFShinMaruGoPro"
                          fontWeight="500"
                        >
                          <tspan x="0" y="0">
                            {number}
                          </tspan>
                        </text>
                      </g>
                    </svg>
                  </div>
                </>
              )}
            </>
          </MediaQuery>
          <MediaQuery maxWidth={BREAK_POINT}>
            <>
              {isDE ? (
                <>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="32"
                      viewBox="0 0 19 32"
                    >
                      <g id="Group_7368" data-name="Group 7368" transform="translate(49 -340.635)">
                        <rect
                          id="Rectangle_4215"
                          data-name="Rectangle 4215"
                          width="19"
                          height="24"
                          transform="translate(-49 346.635)"
                          fill="#464646"
                        />
                        <text
                          id="_0"
                          data-name="0"
                          transform="translate(-46 366.635)"
                          fill="#fff"
                          fontSize="22"
                          fontFamily="AOTFShinMaruGoPro"
                          fontWeight="500"
                        >
                          <tspan x="0" y="0">
                            0
                          </tspan>
                        </text>
                      </g>
                    </svg>
                  </div>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="32"
                      viewBox="0 0 19 32"
                    >
                      <g id="Group_7368" data-name="Group 7368" transform="translate(49 -340.635)">
                        <rect
                          id="Rectangle_4215"
                          data-name="Rectangle 4215"
                          width="19"
                          height="24"
                          transform="translate(-49 346.635)"
                          fill="#464646"
                        />
                        <text
                          id="_0"
                          data-name="0"
                          transform="translate(-46 366.635)"
                          fill="#fff"
                          fontSize="22"
                          fontFamily="AOTFShinMaruGoPro"
                          fontWeight="500"
                        >
                          <tspan x="0" y="0">
                            {number}
                          </tspan>
                        </text>
                      </g>
                    </svg>
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="46"
                      viewBox="0 0 19 32"
                    >
                      <g id="Group_7368" data-name="Group 7368" transform="translate(49 -340.635)">
                        <rect
                          id="Rectangle_4215"
                          data-name="Rectangle 4215"
                          width="19"
                          height="24"
                          transform="translate(-49 346.635)"
                          fill="#464646"
                        />
                        <text
                          id="_0"
                          data-name="0"
                          transform="translate(-46 366.635)"
                          fill="#fff"
                          fontSize="22"
                          fontFamily="AOTFShinMaruGoPro"
                          fontWeight="500"
                        >
                          <tspan x="0" y="0">
                            0
                          </tspan>
                        </text>
                      </g>
                    </svg>
                  </div>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="46"
                      viewBox="0 0 19 32"
                    >
                      <g id="Group_7368" data-name="Group 7368" transform="translate(49 -340.635)">
                        <rect
                          id="Rectangle_4215"
                          data-name="Rectangle 4215"
                          width="19"
                          height="24"
                          transform="translate(-49 346.635)"
                          fill="#464646"
                        />
                        <text
                          id="_0"
                          data-name="0"
                          transform="translate(-46 366.635)"
                          fill="#fff"
                          fontSize="22"
                          fontFamily="AOTFShinMaruGoPro"
                          fontWeight="500"
                        >
                          <tspan x="0" y="0">
                            {number}
                          </tspan>
                        </text>
                      </g>
                    </svg>
                  </div>
                </>
              )}
            </>
          </MediaQuery>
        </>
      );
    }
    return (
      <>
        <MediaQuery minWidth={BREAK_POINT + 1}>
          <>
            {isDE ? (
              <>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="46"
                    viewBox="0 0 40 70"
                  >
                    <g id="Group_7366" data-name="Group 7366" transform="translate(-713 -1047)">
                      <rect
                        id="Rectangle_4216"
                        data-name="Rectangle 4216"
                        width="40"
                        height="50"
                        transform="translate(713 1060)"
                        fill="#464646"
                      />
                      <text
                        id="_0"
                        data-name="0"
                        transform="translate(719 1103)"
                        fill="#fff"
                        fontSize="48"
                        fontFamily="AOTFShinMaruGoPro"
                        fontWeight="500"
                      >
                        <tspan x="0" y="0">
                          {Math.floor(number / 10)}
                        </tspan>
                      </text>
                    </g>
                  </svg>
                </div>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="46"
                    viewBox="0 0 40 70"
                  >
                    <g id="Group_7366" data-name="Group 7366" transform="translate(-713 -1047)">
                      <rect
                        id="Rectangle_4216"
                        data-name="Rectangle 4216"
                        width="40"
                        height="50"
                        transform="translate(713 1060)"
                        fill="#464646"
                      />
                      <text
                        id="_0"
                        data-name="0"
                        transform="translate(719 1103)"
                        fill="#fff"
                        fontSize="48"
                        fontFamily="AOTFShinMaruGoPro"
                        fontWeight="500"
                      >
                        <tspan x="0" y="0">
                          {number % 10}
                        </tspan>
                      </text>
                    </g>
                  </svg>
                </div>
              </>
            ) : (
              <>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="70"
                    viewBox="0 0 40 70"
                  >
                    <g id="Group_7366" data-name="Group 7366" transform="translate(-713 -1047)">
                      <rect
                        id="Rectangle_4216"
                        data-name="Rectangle 4216"
                        width="40"
                        height="50"
                        transform="translate(713 1060)"
                        fill="#464646"
                      />
                      <text
                        id="_0"
                        data-name="0"
                        transform="translate(719 1103)"
                        fill="#fff"
                        fontSize="48"
                        fontFamily="AOTFShinMaruGoPro"
                        fontWeight="500"
                      >
                        <tspan x="0" y="0">
                          {Math.floor(number / 10)}
                        </tspan>
                      </text>
                    </g>
                  </svg>
                </div>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="70"
                    viewBox="0 0 40 70"
                  >
                    <g id="Group_7366" data-name="Group 7366" transform="translate(-713 -1047)">
                      <rect
                        id="Rectangle_4216"
                        data-name="Rectangle 4216"
                        width="40"
                        height="50"
                        transform="translate(713 1060)"
                        fill="#464646"
                      />
                      <text
                        id="_0"
                        data-name="0"
                        transform="translate(719 1103)"
                        fill="#fff"
                        fontSize="48"
                        fontFamily="AOTFShinMaruGoPro"
                        fontWeight="500"
                      >
                        <tspan x="0" y="0">
                          {number % 10}
                        </tspan>
                      </text>
                    </g>
                  </svg>
                </div>
              </>
            )}
          </>
        </MediaQuery>
        <MediaQuery maxWidth={BREAK_POINT}>
          <>
            {isDE ? (
              <>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="32"
                    viewBox="0 0 19 32"
                  >
                    <g id="Group_7368" data-name="Group 7368" transform="translate(49 -340.635)">
                      <rect
                        id="Rectangle_4215"
                        data-name="Rectangle 4215"
                        width="19"
                        height="24"
                        transform="translate(-49 346.635)"
                        fill="#464646"
                      />
                      <text
                        id="_0"
                        data-name="0"
                        transform="translate(-46 366.635)"
                        fill="#fff"
                        fontSize="22"
                        fontFamily="AOTFShinMaruGoPro"
                        fontWeight="500"
                      >
                        <tspan x="0" y="0">
                          {Math.floor(number / 10)}
                        </tspan>
                      </text>
                    </g>
                  </svg>
                </div>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="32"
                    viewBox="0 0 19 32"
                  >
                    <g id="Group_7368" data-name="Group 7368" transform="translate(49 -340.635)">
                      <rect
                        id="Rectangle_4215"
                        data-name="Rectangle 4215"
                        width="19"
                        height="24"
                        transform="translate(-49 346.635)"
                        fill="#464646"
                      />
                      <text
                        id="_0"
                        data-name="0"
                        transform="translate(-46 366.635)"
                        fill="#fff"
                        fontSize="22"
                        fontFamily="AOTFShinMaruGoPro"
                        fontWeight="500"
                      >
                        <tspan x="0" y="0">
                          {number % 10}
                        </tspan>
                      </text>
                    </g>
                  </svg>
                </div>
              </>
            ) : (
              <>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="46"
                    viewBox="0 0 19 32"
                  >
                    <g id="Group_7368" data-name="Group 7368" transform="translate(49 -340.635)">
                      <rect
                        id="Rectangle_4215"
                        data-name="Rectangle 4215"
                        width="19"
                        height="24"
                        transform="translate(-49 346.635)"
                        fill="#464646"
                      />
                      <text
                        id="_0"
                        data-name="0"
                        transform="translate(-46 366.635)"
                        fill="#fff"
                        fontSize="22"
                        fontFamily="AOTFShinMaruGoPro"
                        fontWeight="500"
                      >
                        <tspan x="0" y="0">
                          {Math.floor(number / 10)}
                        </tspan>
                      </text>
                    </g>
                  </svg>
                </div>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="46"
                    viewBox="0 0 19 32"
                  >
                    <g id="Group_7368" data-name="Group 7368" transform="translate(49 -340.635)">
                      <rect
                        id="Rectangle_4215"
                        data-name="Rectangle 4215"
                        width="19"
                        height="24"
                        transform="translate(-49 346.635)"
                        fill="#464646"
                      />
                      <text
                        id="_0"
                        data-name="0"
                        transform="translate(-46 366.635)"
                        fill="#fff"
                        fontSize="22"
                        fontFamily="AOTFShinMaruGoPro"
                        fontWeight="500"
                      >
                        <tspan x="0" y="0">
                          {number % 10}
                        </tspan>
                      </text>
                    </g>
                  </svg>
                </div>
              </>
            )}
          </>
        </MediaQuery>
      </>
    );
  };

  const formatCountNumber = (number) => {
    if (number < 10) {
      return `00${number}`;
    }
    if (number < 100) {
      return `0${number}`;
    }
    if (number < 1000) return `${number}`;
    return number;
  };

  useEffect(() => {
    if (stepOpenBox === STEP_OPEN_BOX.OPEN) {
      setTimeout(() => {
        setStepOpenBox(STEP_OPEN_BOX.PUSH_CARD);
      }, 2700);
    }
  }, [stepOpenBox]);

  const [isCheckBox, setIsCheckBox] = useState(true);
  const handleOpenBox = (type) => {
    setColor(type);
    setIsCheckBox(false);
    setTimeout(() => {
      setStepOpenBox(1);
    }, 2000);
  };

  return (
    <>
      <TopHeader title="" show="false" />
      <div className="popup-wrapper" style={{ position: 'relative' }}>
        {isScratchWChance ? (
          <ScratchWChanceWrapper className="scratch-wrapper">
            <div className="border-top-red"></div>
            <ButtonSkip
              onClick={() => handleMoveResult(orderId)}
              style={{
                display:
                  step === STEP.SHOW_W_CHANCE_TICKET ||
                  step === STEP.SHOW_W_CHANCE_ANIMATION_1 ||
                  step === STEP.SHOW_W_CHANCE_ANIMATION_2 ||
                  (dataTrial && dataTrial.skip_button_can_show == SKIP_SCRATCH.notShow)
                    ? 'none'
                    : 'block',
              }}
            />
            <div
              id="w-change-ticket"
              onClick={() => handleNextStep()}
              style={{ cursor: 'pointer' }}
            >
              <img src={WChanceTicket} width="100%" height="100%" />
            </div>

            <div id="footer-scratch">
              <img src={dottedScratchPC} className="dotted-top-PC" />
              <img src={dottedScratchSP} className="dotted-top-SP" />
              <div className="border-yellow-onchallenge"></div>
              <div className="border-dot AOTFShinMaruGoPro">当たりが出ればスペシャル商品GET！</div>
              <img src={dottedScratchPC} className="dotted-bottom-PC" />
              <img src={dottedScratchSP} className="dotted-bottom-SP" />
            </div>
          </ScratchWChanceWrapper>
        ) : (
          <ScratchWrapper className="scratch-wrapper">
            <div
              style={{
                opacity: isShowModalScratch ? 0 : 1,
                transition: 'all 0.1s ease-in-out',
              }}
            >
              <div id="quantity" className="AOTFShinMaruGoPro">
                <span>
                  {formatCountNumber(counter + 1) <= formatCountNumber(prizesData.length)
                    ? formatCountNumber(counter + 1)
                    : formatCountNumber(prizesData.length)}{' '}
                  / {formatCountNumber(prizesData.length)}
                </span>
              </div>
              <ButtonSkip
                style={{
                  display:
                    dataTrial && dataTrial.skip_button_can_show == SKIP_SCRATCH.notShow
                      ? 'none'
                      : 'block',
                }}
                onClick={() => handleMoveResult(orderId)}
              />
            </div>

            {type === 'package' ? (
              <div className="content-scratch-package-wrapper">
                {stepOpenBox ? (
                  <div className="animation" style={{ overflow: 'none' }}>
                    <div style={{ display: selectedBoxColor === 'Yellow' ? 'block' : 'none' }}>
                      <img
                        src={OpenBoxYellow}
                        alt="animation"
                        id="animation_open_box"
                        style={{
                          position: 'absolute',
                          width: '100%',
                          display: stepOpenBox === STEP_OPEN_BOX.OPEN ? 'unset' : 'none',
                        }}
                      />
                      <img
                        src={GiftBoxYellow}
                        width="100%"
                        id="animation_push_card"
                        style={{ display: stepOpenBox === STEP_OPEN_BOX.OPEN ? 'none' : 'block' }}
                      />
                    </div>
                    <div style={{ display: selectedBoxColor === 'Red' ? 'block' : 'none' }}>
                      <img
                        src={OpenBoxRed}
                        alt="animation"
                        id="animation_open_box"
                        style={{
                          position: 'absolute',
                          width: '100%',
                          display: stepOpenBox === STEP_OPEN_BOX.OPEN ? 'unset' : 'none',
                        }}
                      />
                      <img
                        src={GiftBoxRed}
                        width="100%"
                        id="animation_push_card"
                        style={{ display: stepOpenBox === STEP_OPEN_BOX.OPEN ? 'none' : 'block' }}
                      />
                    </div>
                    <div style={{ display: selectedBoxColor === 'Blue' ? 'block' : 'none' }}>
                      <img
                        src={OpenBoxBlue}
                        alt="animation"
                        id="animation_open_box"
                        style={{
                          position: 'absolute',
                          width: '100%',
                          display: stepOpenBox === STEP_OPEN_BOX.OPEN ? 'unset' : 'none',
                        }}
                      />
                      <img
                        src={GiftBoxBlue}
                        width="100%"
                        id="animation_push_card"
                        style={{ display: stepOpenBox === STEP_OPEN_BOX.OPEN ? 'none' : 'block' }}
                      />
                    </div>
                  </div>
                ) : (
                  <div id="box-wrapper">
                    <BoxAnimation
                      className="box"
                      id="box1"
                      onClick={isCheckBox ? () => handleOpenBox('Yellow') : () => {}}
                      isShow={selectedBoxColor === 'Yellow'}
                    >
                      <img src={Box1} width="100%" height="100%" />
                    </BoxAnimation>
                    <div className="d-flex justify-content-center">
                      <BoxAnimation
                        className="box"
                        id="box2"
                        onClick={isCheckBox ? () => handleOpenBox('Red') : () => {}}
                        isShow={selectedBoxColor === 'Red'}
                      >
                        <img src={Box2} width="100%" height="100%" />
                      </BoxAnimation>
                      <BoxAnimation
                        className="box"
                        id="box3"
                        onClick={isCheckBox ? () => handleOpenBox('Blue') : () => {}}
                        isShow={selectedBoxColor === 'Blue'}
                      >
                        <img src={Box3} width="100%" height="100%" />
                      </BoxAnimation>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="d-flex flex-wrap justify-content-center content-scratch-wrapper">
                {renderListScratchItem()}
              </div>
            )}

            {stepOpenBox ? (
              <div id="scratch-package-result-wrapper">
                <div id="abc-wrapper">
                  <div className="result">
                    <div className="result__rank-name">
                      <MediaQuery minWidth={BREAK_POINT + 1}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="68"
                          height="84"
                          viewBox="0 0 80 84"
                        >
                          <text
                            id="A賞"
                            transform="translate(0 67)"
                            fill="#fff"
                            fontSize="58"
                            fontFamily="AOTFShinMaruGoPro"
                            fontWeight="700"
                          >
                            <tspan x="0" y="0">
                              A
                            </tspan>
                            <tspan y="0" fontSize="26">
                              賞
                            </tspan>
                          </text>
                        </svg>
                      </MediaQuery>
                      <MediaQuery maxWidth={BREAK_POINT}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="41"
                          height="54"
                          viewBox="0 0 50 54"
                        >
                          <text
                            id="A賞"
                            transform="translate(1 43)"
                            fill="#fff"
                            fontSize="37"
                            fontFamily="AOTFShinMaruGoPro"
                            fontWeight="700"
                          >
                            <tspan x="0" y="0">
                              A
                            </tspan>
                            <tspan y="0" fontSize="16">
                              賞
                            </tspan>
                          </text>
                        </svg>
                      </MediaQuery>
                    </div>
                    <div className="result_quantity">{formatNumber(rankACounter)}</div>
                  </div>
                  <div className="result">
                    <div className="result__rank-name">
                      <MediaQuery minWidth={BREAK_POINT + 1}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="68"
                          height="84"
                          viewBox="0 0 80 84"
                        >
                          <text
                            id="B賞"
                            transform="translate(0 67)"
                            fill="#fff"
                            fontSize="58"
                            fontFamily="AOTFShinMaruGoPro"
                            fontWeight="700"
                          >
                            <tspan x="0" y="0">
                              B
                            </tspan>
                            <tspan y="0" fontSize="26">
                              賞
                            </tspan>
                          </text>
                        </svg>
                      </MediaQuery>
                      <MediaQuery maxWidth={BREAK_POINT}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="41"
                          height="54"
                          viewBox="0 0 50 54"
                        >
                          <text
                            id="B賞"
                            transform="translate(1 43)"
                            fill="#fff"
                            fontSize="37"
                            fontFamily="AOTFShinMaruGoPro"
                            fontWeight="700"
                          >
                            <tspan x="0" y="0">
                              B
                            </tspan>
                            <tspan y="0" fontSize="16">
                              賞
                            </tspan>
                          </text>
                        </svg>
                      </MediaQuery>
                    </div>
                    <div className="result_quantity">{formatNumber(rankBCounter)}</div>
                  </div>
                  <div className="result">
                    <div className="result__rank-name">
                      <MediaQuery minWidth={BREAK_POINT + 1}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="68"
                          height="84"
                          viewBox="0 0 80 84"
                        >
                          <text
                            id="C賞"
                            transform="translate(0 67)"
                            fill="#fff"
                            fontSize="58"
                            fontFamily="AOTFShinMaruGoPro"
                            fontWeight="700"
                          >
                            <tspan x="0" y="0">
                              C
                            </tspan>
                            <tspan y="0" fontSize="26">
                              賞
                            </tspan>
                          </text>
                        </svg>
                      </MediaQuery>
                      <MediaQuery maxWidth={BREAK_POINT}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="41"
                          height="54"
                          viewBox="0 0 50 54"
                        >
                          <text
                            id="C賞"
                            transform="translate(1 43)"
                            fill="#fff"
                            fontSize="37"
                            fontFamily="AOTFShinMaruGoPro"
                            fontWeight="700"
                          >
                            <tspan x="0" y="0">
                              C
                            </tspan>
                            <tspan y="0" fontSize="16">
                              賞
                            </tspan>
                          </text>
                        </svg>
                      </MediaQuery>
                    </div>
                    <div className="result_quantity">{formatNumber(rankCCounter)}</div>
                  </div>
                </div>
                <div id="de-wrapper">
                  <div className="result-de">
                    <div className="result__rank-name result__rank-name_D_E">
                      <MediaQuery minWidth={BREAK_POINT + 1}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="41"
                          height="54"
                          viewBox="0 0 50 54"
                        >
                          <text
                            id="D賞"
                            transform="translate(1 43)"
                            fill="#fff"
                            fontSize="37"
                            fontFamily="AOTFShinMaruGoPro"
                            fontWeight="700"
                          >
                            <tspan x="0" y="0">
                              D
                            </tspan>
                            <tspan y="0" fontSize="16">
                              賞
                            </tspan>
                          </text>
                        </svg>
                      </MediaQuery>
                      <MediaQuery maxWidth={BREAK_POINT}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="39"
                          viewBox="0 0 37 39"
                        >
                          <text
                            id="D賞"
                            transform="translate(0 31)"
                            fill="#fff"
                            fontSize="27"
                            fontFamily="AOTFShinMaruGoPro"
                            fontWeight="700"
                          >
                            <tspan x="0" y="0">
                              D
                            </tspan>
                            <tspan y="0" fontSize="12">
                              賞
                            </tspan>
                          </text>
                        </svg>
                      </MediaQuery>
                    </div>
                    <div className="result_quantity">{formatNumber(rankDCounter, true)}</div>
                  </div>
                  <div className="result-de">
                    <div className="result__rank-name result__rank-name_D_E">
                      <MediaQuery minWidth={BREAK_POINT + 1}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="41"
                          height="54"
                          viewBox="0 0 50 54"
                        >
                          <text
                            id="E賞"
                            transform="translate(1 43)"
                            fill="#fff"
                            fontSize="37"
                            fontFamily="AOTFShinMaruGoPro"
                            fontWeight="700"
                          >
                            <tspan x="0" y="0">
                              E
                            </tspan>
                            <tspan y="0" fontSize="16">
                              賞
                            </tspan>
                          </text>
                        </svg>
                      </MediaQuery>
                      <MediaQuery maxWidth={BREAK_POINT}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="39"
                          viewBox="0 0 35 39"
                        >
                          <text
                            id="E賞"
                            transform="translate(0 31)"
                            fill="#fff"
                            fontSize="27"
                            fontFamily="AOTFShinMaruGoPro"
                            fontWeight="700"
                          >
                            <tspan x="0" y="0">
                              E
                            </tspan>
                            <tspan y="0" fontSize="12">
                              賞
                            </tspan>
                          </text>
                        </svg>
                      </MediaQuery>
                    </div>
                    <div className="result_quantity">{formatNumber(rankECounter, true)}</div>
                  </div>
                </div>
                <div className="border-yellow"></div>
              </div>
            ) : (
              <div id="footer-scratch">
                <img src={dottedScratchPC} className="dotted-top-PC" />
                <img src={dottedScratchSP} className="dotted-top-SP" />
                <div className="border-dot AOTFShinMaruGoPro">
                  {Number(adult) === 1 ? '好きな箱を選んでね！' : '好きなカードを選んでね！'}
                </div>
                <img src={dottedScratchPC} className="dotted-bottom-PC" />
                <img src={dottedScratchSP} className="dotted-bottom-SP" />
                {type === 'package' && <div className="border-yellow"></div>}
                {type === 'retail' && <div className="border-yellow-retail"></div>}
              </div>
            )}
          </ScratchWrapper>
        )}
      </div>

      <Modal
        size="lg"
        show={isShowModalScratch}
        centered
        className="modal-scratch"
        animation={false}
      >
        <Modal.Body>
          <div
            className={type === 'package' ? 'scratch-content my-ml-15px-unset' : 'scratch-content'}
          >
            {/* {step !== STEP.SHOW_W_CHANCE_RESULT && (
              <div
                className="skip-quantity-custom"
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: step === STEP.SHOW_RESULT ? '120px' : '20px',
                }}
              >
                <div
                  className="quantity-custom-modal"
                  style={{
                    display:
                      step === STEP.SHOW_W_CHANCE_TICKET ||
                      step === STEP.SHOW_W_CHANCE_ANIMATION_1 ||
                      step === STEP.SHOW_W_CHANCE_ANIMATION_2
                        ? 'none'
                        : 'block',
                  }}
                >
                  <span>
                    {formatCountNumber(counter + 1) <= formatCountNumber(prizesData.length)
                      ? formatCountNumber(counter + 1)
                      : formatCountNumber(prizesData.length)}{' '}
                    / {formatCountNumber(prizesData.length)}
                  </span>
                </div>
                <div className="skip-btn-custom-modal">
                  <ButtonSkipCustom onClick={() => handleMoveResult(orderId)} />
                </div>
              </div>
            )} */}

            <div
              className={
                (step === STEP.SHOW_W_CHANCE_RESULT && !isEmpty(wChanceData)) ||
                step === STEP.SHOW_RESULT ||
                step === STEP.SHOW_W_CHANCE_ANIMATION_2
                  ? 'wrap_scratch_item_scale height-unset width-custom'
                  : step === STEP.SHOW_W_CHANCE_RESULT && isEmpty(wChanceData)
                  ? 'wrap_scratch_item_scale width-custom-no-data'
                  : 'wrap_scratch_item_scale'
              }
            >
              <div
                style={{
                  display: step === STEP.OPEN_MODAL ? 'block' : 'none',
                  opacity: step === STEP.OPEN_MODAL ? 1 : 0,
                  transition: 'all 0.1s linear',
                  position: 'relative',
                }}
                onClick={() => handleNextStep(prizesData[counter]?.rank_name)}
              >
                <img src={ScratchScale} className="scratch-item-scale" />
                <div className="wrap_scratch_item_scale_bg" />
              </div>
              {/* {(step === STEP.SCRATCH || step === STEP.SHOW_SCRATCH) && ( */}
              <div
                style={{
                  position: 'absolute',
                  top: '0',
                  display: step === STEP.SCRATCH || step === STEP.SHOW_SCRATCH ? 'block' : 'none',
                  opacity: step === STEP.SCRATCH || step === STEP.SHOW_SCRATCH ? 1 : 0,
                  left: '50%',
                  transform: 'translate(-50%, 0)',
                  width: '100%',
                  zIndex: 7,
                }}
                onClick={() => handleNextStep(prizesData[counter]?.rank_name)}
              >
                <img
                  src={convertRankNameToAnimation(prizesData[counter]?.rank_name)}
                  className="scratch-item-scale 1"
                />
                <div className="wrap_scratch_item_scale_bg" />
              </div>

              {/* {step === STEP.SHOW_RESULT && ( */}
              <div
                id="result-scratch"
                style={{
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  transform: 'translate(-50%, -35%)',
                  marginLeft: '10px',
                  display: step === STEP.SHOW_RESULT ? 'block' : 'none',
                  opacity: step === STEP.SHOW_RESULT ? 1 : 0,
                  // transition: 'all 0.1s linear',
                  zIndex: 8,
                }}
              >
                {prizesData[counter]?.is_new && <img src={NewTag} id="new-tag" />}
                <img src={valueRankByPrizeWon.image} id="scratch-item-prize" />
                <div id="prize-name">
                  <div className={`name ${userAgent}`}>
                    <span className="prize-name__rank-name">{prizesData[counter]?.rank_name}</span>
                    <span className="prize-name__sub-rank-name">賞</span>
                  </div>
                  <img src={dottedYellowScratchPC} className="dotted-result-top-PC" />
                  <img src={dottedYellowScratchSP} className="dotted-result-top-SP" />
                  <div className="prize-name__title AOTFShinMaruGoPro">
                    {valueRankByPrizeWon.title}
                  </div>
                  <img src={dottedYellowScratchPC} className="dotted-result-bottom-PC" />
                  <img src={dottedYellowScratchSP} className="dotted-result-bottom-SP" />
                </div>

                <div className="btn-next">
                  <img className="get-image" src={getImage} />
                  <img
                    src={NextButton}
                    className="next"
                    onClick={() => handleNextStep(prizesData[counter]?.rank_name)}
                  />
                </div>
              </div>

              <div
                id="choose-prize-scratch"
                style={{
                  position: 'absolute',
                  display: step === STEP.SHOW_POPUP_CHOOSE_PRIZE ? 'block' : 'none',
                  opacity: step === STEP.SHOW_POPUP_CHOOSE_PRIZE ? 1 : 0,
                  // transition: 'all 0.1s linear',
                  zIndex: 8,
                }}
              >
                {prizesData[counter]?.is_new && <img src={NewTag} id="new-tag" />}
                <div className="list-prize">
                  {listPrizeCanChange.length > 0 &&
                    listPrizeCanChange.map((item, index) => (
                      <div key={item.id} className="list-prize-item">
                        <div className="list-prize-item-image">
                          <img src={item?.image?.image_url} className="list-prize-image" />
                        </div>
                        <div className="list-prize-item-title AOTFShinMaruGoPro">
                          <div className="list-prize-item-check">
                            <input
                              type="radio"
                              className="list-prize-check"
                              checked={valuePrizeCanChange == item.prize_id}
                              value={item.prize_id}
                              onChange={(e) => {
                                setValuePrizeCanChange(e.target.value);
                                setIsBgNextChoosePrize(false);
                              }}
                              disabled={dataTrial.has_use_quantity === true && item.quantity <= 0}
                            />
                          </div>
                          <div className="list-prize-content">
                            {prizesData[counter]?.rank_name} - {index + 1} {item.title}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
                <div id="prize-name">
                  <img
                    src={dottedYellowChoosePrizePC}
                    className="dotted-result-top-PC"
                    style={{ right: '5px' }}
                  />
                  <img src={dottedYellowScratchSP} className="dotted-result-top-SP" />
                  <div className={`name ${userAgent}`}>
                    <span className="prize-name__rank-name">{prizesData[counter]?.rank_name}</span>
                    <span className="prize-name__sub-rank-name">賞</span>
                  </div>
                  <div className="prize-name__title AOTFShinMaruGoPro">
                    ほしい商品を選択してください
                  </div>
                  <img
                    src={dottedYellowChoosePrizePC}
                    className="dotted-result-bottom-PC"
                    style={{ right: '5px' }}
                  />
                  <img src={dottedYellowScratchSP} className="dotted-result-bottom-SP" />
                </div>

                <div className="btn-next">
                  <img className="get-image" src={getImage} />
                  <div className="next">
                    <img
                      src={NextButton}
                      onClick={() => handleNextStep(prizesData[counter]?.rank_name)}
                    />
                    <div className={isBgNextChoosePrize ? 'bg_next_choose_prize' : ''}></div>
                  </div>
                </div>
              </div>

              <div onClick={() => handleNextStep(prizesData[counter]?.rank_name)}>
                <img
                  src={WChanceTicket}
                  className="scratch-item-scale"
                  style={{
                    position: 'absolute',
                    top: '0',
                    display: step === STEP.SHOW_W_CHANCE_TICKET ? 'block' : 'none',
                    opacity: step === STEP.SHOW_W_CHANCE_TICKET ? 1 : 0,
                    zIndex: 9,
                  }}
                />
                <div
                  className="wrap_scratch_item_scale_bg"
                  style={{
                    display: step === STEP.SHOW_W_CHANCE_TICKET ? 'block' : 'none',
                  }}
                />
              </div>

              {/* {step === STEP.SHOW_W_CHANCE_ANIMATION_1 && ( */}
              <div
                style={{
                  position: 'absolute',
                  top: '0',
                  display: step === STEP.SHOW_W_CHANCE_ANIMATION_1 ? 'block' : 'none',
                  zIndex: 10,
                }}
                className="w-chance-image-show-gif1"
              >
                <img
                  src={animations.image_on_challenge ? animations.image_on_challenge[0] : ''}
                  className="scratch-item-scale"
                />
                <div className="wrap_scratch_item_scale_bg" />
              </div>
              {/* {step === STEP.SHOW_W_CHANCE_ANIMATION_2 && ( */}
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  display: step === STEP.SHOW_W_CHANCE_ANIMATION_2 ? 'block' : 'none',
                  transition: 'all 0.1s ease-im-out',
                  zIndex: 11,
                  marginTop: '-20px',
                }}
                className="w-chance-image-show-gif2"
              >
                <img
                  src={animations.image_on_challenge ? animations.image_on_challenge[1] : ''}
                  className="scratch-item-scale scratch-item-scale-custom"
                  style={{
                    backgroundImage: `url(${wChangeAnimation2})`,
                    backgroundSize: '100% 100%',
                  }}
                />
                <div className="wrap_scratch_item_scale_bg" />
                <div className="wrap_scratch_item_scale_bg wrap_scratch_item_scale_bg-custom" />
              </div>

              {/* {step === STEP.SHOW_W_CHANCE_RESULT && isEmpty(wChanceData) && ( */}
              <div
                style={{
                  position: 'absolute',
                  top: '0px',
                  left: '0px',
                  marginTop: '-21px',
                  display:
                    step === STEP.SHOW_W_CHANCE_RESULT && isEmpty(wChanceData) ? 'block' : 'none',
                  opacity: step === STEP.SHOW_W_CHANCE_RESULT && isEmpty(wChanceData) ? 1 : 0,
                  transition: 'all 0.5s ease-in-out',
                  zIndex: 12,
                }}
                className="w-chance-image"
              >
                <img src={WChanceMiss} className="scratch-item-scale" />
                <div className="btn-next" style={{ textAlign: 'end', marginTop: '21px' }}>
                  <img
                    src={NextButton}
                    style={{ width: '163px', height: '54px' }}
                    onClick={() => handleNextStep(prizesData[counter]?.rank_name)}
                  />
                </div>
                <div className="wrap_scratch_item_scale_bg wrap_scratch_item_scale_bg_faild" />
              </div>

              {/* {step === STEP.SHOW_W_CHANCE_RESULT && !isEmpty(wChanceData) && ( */}
              <div
                id="result-scratch"
                style={{
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  transform: 'translate(-50%, -35%)',
                  display:
                    step === STEP.SHOW_W_CHANCE_RESULT && !isEmpty(wChanceData) ? 'block' : 'none',
                  opacity: step === STEP.SHOW_W_CHANCE_RESULT && !isEmpty(wChanceData) ? 1 : 0,
                  transition: 'all ease-in-out',
                }}
              >
                <div id="w-chance-result">
                  <img src={Congratulations} id="congratulations" />
                  <img src={wChanceData?.image?.image_url} id="scratch-item-w-chance" />
                  <div className="w-chance-result-footer-custom">
                    <img src={dottedYellowScratchPC} className="dotted-result-top-PC" />
                    <img src={dottedYellowScratchSP} className="dotted-result-top-SP" />
                    <div className="name">
                      <img src={WChanceOn} className="w-chance-img-on" />
                    </div>
                    <span className="description AOTFShinMaruGoPro">{wChanceData?.title}</span>
                    <img src={dottedYellowScratchPC} className="dotted-result-bottom-PC" />
                    <img src={dottedYellowScratchSP} className="dotted-result-bottom-SP" />
                  </div>
                </div>
                <div className="btn-next-w-chance">
                  <img
                    src={NextButton}
                    onClick={() => handleNextStep(prizesData[counter]?.rank_name)}
                  />
                </div>
              </div>
            </div>

            {[
              STEP.OPEN_MODAL,
              STEP.SHOW_SCRATCH,
              STEP.SCRATCH,
              STEP.SHOW_W_CHANCE_TICKET,
              STEP.SHOW_W_CHANCE_ANIMATION_1,
            ].includes(step) && (
              <div
                className="next-button NotoSansJP"
                onClick={() => handleNextStep(prizesData[counter]?.rank_name)}
              >
                タップしてクジをめくる
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
